import { Box } from '@factorialco/deprecated-design-system'
import {
  ExpensesExpensableFiltersInput,
  ProjectionKind,
  useExpensesByEmployeeDatatable,
} from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { InlineEmployee } from 'modules/employees/components/InlineEmployee'
import { usePageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'

import Money from '../Money'

interface ExpenesByEmployeeDatatableProps {
  filters: ExpensesExpensableFiltersInput
}

const ExpenesByEmployeeDatatable: React.FC<ExpenesByEmployeeDatatableProps> = ({ filters }) => {
  const { company } = useCurrentSession()

  const { dateFilters } = usePageDateFilters()

  const source = useExpensesByEmployeeDatatable(
    [
      {
        identifier: 'employeeId',
        title: i18n.t('expenses_v2.reports.expenses_by_employee.columns.employee'),
        kind: ProjectionKind.Custom,
        template: '{{ employeeId }}',
        render: ({ employee }) => {
          return (
            <Box flexDirection="row" alignItems="center" gap="s16">
              <InlineEmployee
                employee={employee}
                variant="medium"
                linkProfile
                textContainerWidth="s240"
              />
            </Box>
          )
        },
      },
      {
        identifier: 'totalAmount',
        title: i18n.t('expenses_v2.reports.expenses_by_employee.columns.spent'),
        kind: ProjectionKind.Custom,
        template: '{{ totalAmount }}',
        render: ({ totalAmount }) => {
          return <Money amount={totalAmount} currency={filters.currency} />
        },
        sortBy: 'totalAmount',
      },
    ],
    {
      variables: {
        companyId: company.id,
        from: dateFilters.startDate.toISOString(),
        to: dateFilters.endDate.toISOString(),
        filters: { ...filters },
      },
    }
  )

  return (
    <Box height="s400" maxHeight="s400" overflowY="auto">
      <DataTable
        disableExport
        source={source}
        pagination={{ kind: 'offset', itemsPerPage: 50, infiniteScroll: true }}
        disableEditColumns
        sort={{ path: 'totalAmount', direction: 'desc' }}
      />
    </Box>
  )
}

export default ExpenesByEmployeeDatatable
